import * as React from 'react';
import { useSelector } from 'react-redux';

const Input = (props) => {
  const {
    label,
    value,
    initialValue,
    handler,
    isEnabled,
  } = props;

  return (
    <label>
      <input
        type='radio'
        name='theme'
        value={value}
        checked={value === initialValue}
        onChange={handler}
        disabled={isEnabled === false}/> <span>{label}</span>
    </label>
  );
};

/**
 * Theming form component.
 *
 * @param {Function} callback
 * @param {String} feature
 *
 * @returns {JSX.Element}
 */
export default function ({callback, feature}) {
  const features = useSelector(state => state.app.features);
  const initialValue = features[feature];
  const isEnabled = features.hasOwnProperty(feature) && features[feature] !== false;
  const onChangeCallback = (e) => callback(e.target.value);

  return (
    <form className='user-settings-form user-settings-form--theming'>
      <Input
        value='auto'
        label={I18n.t('profiles.settings.features.theme.auto')}
        initialValue={initialValue}
        isEnabled={isEnabled}
        handler={onChangeCallback}
      />
      <Input
        value='light'
        label={I18n.t('profiles.settings.features.theme.light')}
        initialValue={initialValue}
        isEnabled={isEnabled}
        handler={onChangeCallback}
      />
      <Input
        value='dark'
        label={I18n.t('profiles.settings.features.theme.dark')}
        initialValue={initialValue}
        isEnabled={isEnabled}
        handler={onChangeCallback}
      />
    </form>
  );
}
